import { DESKTOP, MOBILE } from '@/src/constants'
import { TypographyVariantType } from '@ct-design/lib/Typography/type'
import { DeviceType } from '@/src/types'

type FaqStyleConfig = {
    faqTitleVariant: TypographyVariantType
    faqSectionTitleVariant: TypographyVariantType
    faqQuestionVariant: TypographyVariantType
    faqAnswerVariant: TypographyVariantType
}

const faqStyleConfig: Record<DeviceType, FaqStyleConfig> = {
    [DESKTOP]: {
        faqTitleVariant: 'HM2',
        faqSectionTitleVariant: 'HM3',
        faqQuestionVariant: 'B1',
        faqAnswerVariant: 'B2'
    },
    [MOBILE]: {
        faqTitleVariant: 'HM3',
        faqSectionTitleVariant: 'HM4',
        faqQuestionVariant: 'B2',
        faqAnswerVariant: 'B3'
    }
}

export default faqStyleConfig
